import { API_ADDRESS, get, post } from 'lib/communication';

export const getTowns = async (town: string, pna: string): Promise<string[]> => {
    const route: string = 'postal/getTowns';

    try {
        const data = await get<string[]>(`${API_ADDRESS}${route}?town=${town}&pna=${pna}`);
        if (data.ok && data.parsedBody) {
            return data.parsedBody;
        }
        return [];
    } catch (err) {
        console.log('Error ', err);
        return [];
    }
};

export const getPnas = async (town: string, pna: string): Promise<string[]> => {
    const route: string = 'postal/getPnas';
    try {
        const data = await get<string[]>(`${API_ADDRESS}${route}?town=${town}&pna=${pna}`);
        if (data.ok && data.parsedBody) {
            return data.parsedBody;
        }
        return [];
    } catch (err) {
        console.log('Error ', err);
        return [];
    }
};

export const getPostalsUpdateDate = async (): Promise<string> => {
    const route: string = 'postal/getPostalsUpdateDate';
    try {
        const data = await get<{ date: string }>(`${API_ADDRESS}${route}`);
        if (data.ok && data.parsedBody) {
            return data.parsedBody.date;
        }
        return '';
    } catch (err) {
        console.log('Error ', err);
        return '';
    }
};

export const updatePostals = async (files: File[]) => {
    const route: string = 'postal/updatePostals';

    try {
        const formData = new FormData();
        files.forEach((f) => {
            formData.append('postalsFiles[]', f);
        });
        const data = await post<{ message: string, error: string | undefined }>(`${API_ADDRESS}${route}`, formData);
        if (data.ok && data.parsedBody) {
            if (data.parsedBody.error) {
                console.log('Error in response: ', data.parsedBody.message);
                return data.parsedBody.message;
            }
            return 'Pomyślnie zaktualizowano bazę kodów pocztowych.';
        }
        console.log('Error in response: ', data);
        return 'Wystąpił błąd podczas próby aktualizacji bazy kodów pocztowych.';
    } catch (err) {
        console.log('Error ', err);
        return 'Wystąpił błąd podczas próby aktualizacji bazy kodów pocztowych.';
    }
};
